<template>
  <abbr class="unit-acronym" :title="resolvedTitle">
    <slot>{{ normalizedCode }}</slot>
  </abbr>
</template>

<script>
  import { getAcronymTitle } from "@/utils/acronyms";

  export default {
    name: "AcronymTooltip",
    props: {
      code: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        default: "",
      },
    },
    computed: {
      normalizedCode() {
        return String(this.code || "")
          .trim()
          .toLowerCase();
      },
      resolvedTitle() {
        if (this.title) {
          return this.title;
        }
        return getAcronymTitle(this.normalizedCode);
      },
    },
  };
</script>
